import { useCallback } from 'react'
import i18n from 'i18next'
import { CurrentCountryState, UserAuthState } from '@app/storage'

export const useUpdateLangByCountry = () => {
  const UpdateLangByCountry = useCallback(() => {
    const countryName = CurrentCountryState?.name?.toLowerCase()
    if (!countryName) return

    const existingLang = localStorage.getItem('app_language')
    if (existingLang) return

    const languageMap: Record<string, string> = {
      slovenia: 'si',
      bosnia: 'sr',
      croatia: 'sr',
      serbia: 'sr',
      austria: 'de',
      germany: 'de',
      italy: 'it',
      spain: 'es',
      mexico: 'es',
      'costa rica': 'es',
      'el salvador': 'es',
      guatemala: 'es',
      honduras: 'es',
      nicaragua: 'es',
      panama: 'es',
      cuba: 'es',
      'dominican republic': 'es',
      'puerto rico': 'es',
      argentina: 'es',
      bolivia: 'es',
      chile: 'es',
      colombia: 'es',
      ecuador: 'es',
      paraguay: 'es',
      peru: 'es',
      uruguay: 'es',
      venezuela: 'es',
      'equatorial guinea': 'es',
      brazil: 'pt',
      angola: 'pt',
      'cabo verde': 'pt',
      'guinea-bissau': 'pt',
      mozambique: 'pt',
      portugal: 'pt',
      'sao tome and principe': 'pt',
      'timor-leste': 'pt',
    }

    // Default to English if not matched
    const userLanguage = languageMap[countryName] || 'en'

    // Update user state and app language
    UserAuthState.userLanguageId = userLanguage
    localStorage.setItem('app_language', userLanguage)
    i18n.changeLanguage(userLanguage)
  }, [CurrentCountryState?.name])

  return { UpdateLangByCountry }
}
